import {
    APP,
} from '_pixiSrc/globals';
import * as FEATURES from '_pixiSrc/layout/features';
import {
    default as BaseUI,
} from '_pixiSrc/layout/LoaderUI';

import {
    ASSETS_PATH,
} from './Constants';

class LoaderUI extends BaseUI {
    constructor(layout, loader) {
        super(layout, loader);

        this.button = null;
        this.progressBar = null;

        this.createLayout();

        this.addListeners();
    }

    destructor() {
        super.destructor();
    }

    createLayout() {
        this.container.style.background = `url(${ASSETS_PATH.IMAGES}/loader/background.png)`;
        this.container.style.backgroundSize = 'cover';
        this.container.style.backgroundPosition = '50%';

        // set position of progress bar and display.
        this.progressBar = this.container.appendChild(document.createElement('div'));
        this.progressBar.classList.add('progress-count');

        this.myJackpotLogo = this.container.appendChild(document.createElement('div'));
        this.myJackpotLogo.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/main/my-jackpot-logo.png)`;
        this.myJackpotLogo.classList.add('my-jackpot-logo');

        this.loaderRound = this.container.appendChild(document.createElement('div'));
        this.loaderRound.style.background = `url(${ASSETS_PATH.IMAGES}/loader/loader-new.png)`;
        this.loaderRound.classList.add('loader');
        this.loaderRound.classList.add('loader-rotate');


        this.mainLogo = this.container.appendChild(document.createElement('div'));
        this.mainLogo.style.background = `url(${ASSETS_PATH.IMAGES}/loader/loader-logo.png)`;
        this.mainLogo.classList.add('main-logo');
        this.mainLogo.classList.add('zoom-in');

        // adjust loading screen accroding to screen size
        this.fitLayout();
    }

    fitLayout() {
        const scale = APP.layout.scale * 2;
        let fontSize = 15;
        if (!FEATURES.MOBILE) {
            fontSize = 11;
        }
        fontSize *= scale;

        // set position of progress bar
        const w = 20 * scale;
        const h = 20 * scale;
        const loaderWidth = 200 * scale;
        const loaderHeight = 200 * scale;
        // const lh = 286 * scale;
        const mainLogoWidth = 85 * scale;
        const mainLogoHeight = 85 * scale;
        const myJackpotLogoWidth = 135 * scale;
        const myJackpotLogoHeight = 80 * scale;


        this.progressBar.style.height = 'auto';
        this.progressBar.style.fontSize = `${fontSize}px`;
        this.progressBar.style.marginTop = `${-h / 2 - 12 * scale}px`;
        this.progressBar.style.padding = `${scale * 2}px`;

        this.loaderRound.style.width = `${loaderWidth}px`;
        this.loaderRound.style.marginLeft = `${-loaderWidth / 2}px`;
        this.loaderRound.style.height = `${loaderHeight}px`;
        this.loaderRound.style.marginTop = `${-loaderHeight / 2 - 12 * scale}px`;
        this.loaderRound.style.padding = `${scale * 2}px`;

        this.mainLogo.style.width = `${mainLogoWidth}px`;
        this.mainLogo.style.marginLeft = `${-mainLogoWidth / 2}px`;
        this.mainLogo.style.height = `${mainLogoHeight}px`;
        this.mainLogo.style.marginTop = `${-mainLogoHeight / 2 - 12 * scale}px`;
        this.mainLogo.style.padding = `${scale * 2}px`;

        this.myJackpotLogo.style.width = `${myJackpotLogoWidth}px`;
        this.myJackpotLogo.style.marginLeft = `${-myJackpotLogoWidth / 2}px`;
        this.myJackpotLogo.style.height = `${myJackpotLogoHeight}px`;
        this.myJackpotLogo.style.marginTop = `${-myJackpotLogoHeight / 2 - 12 * scale}px`;
        this.myJackpotLogo.style.padding = `${scale * 2}px`;
    }

    showProgress(prc = 0) {
        this.progressBar.innerHTML = `${~~prc}%`;
    }

    showComplete() {
        this.showProgress(100);
        this.dispatchComplete();
    }
}

export default LoaderUI;
